export default __webpack_public_path__ + "static/media/prevarrow.b0142eb2.svg";